/**
 * Widerrufsbutton – JavaScript
 * =============================
 * Einbinden: <script src="widerruf.js" defer></script>
 *
 * Konfiguration: Nur den Abschnitt "KONFIGURATION" anpassen.
 */

(function () {
  'use strict';

  /* ============================================================
     KONFIGURATION – HIER ANPASSEN
     ============================================================ */
  const KONFIG = {
    // URL zu deinem PHP-Script (absoluter Pfad)
    backendUrl: 'https://ecultor.de/widerruf/widerruf_dipos.php',

    // Cloudflare Turnstile: true = aktiviert (muss auch im PHP aktiviert sein)
    turnstileAktiv: false,
    turnstileSitekey: 'DEIN_SITEKEY', // Aus dem Cloudflare Dashboard

    // Texte je Sprache (Schlüssel = 2-stelliger Code aus <html lang>).
    // Weitere Sprachen einfach als neuen Block ergänzen (z. B. es, fr, nl, it);
    // fehlt eine Sprache, greift automatisch Deutsch.
    texteAlle: {
      de: {
        btnLabel:       'Vertrag widerrufen',
        modalTitel:     'Vertrag widerrufen',
        modalUntertitel:'Fülle das Formular aus. Du erhältst sofort eine Eingangsbestätigung per E-Mail.',
        pflichthinweis: '* Pflichtfelder',
        labelName:      'Vollständiger Name',
        labelEmail:     'E-Mail-Adresse',
        labelArtikel:   'Bestellnummer (sofern bekannt) und/oder die betreffenden Artikel',
        labelArtikelHint: 'z. B. Bestellung #12345, daraus Artikel ...',
        labelNachricht: 'Weitere Angaben (optional)',
        btnAbschicken:  'Widerruf bestätigen',
        btnLaedt:       'Wird gesendet…',
        erfolg:         'Du erhältst eine Eingangsbestätigung per E-Mail!',
        erfolgText:     'Bitte prüfe deinen Posteingang: ',
        erfolgId:       'Referenz-Nr.',
        erfolgOhneMail: 'Widerruf übermittelt',
        erfolgOhneMailText: 'Dein Widerruf wurde an uns übermittelt. Die Bestätigungsmail konnte leider nicht zugestellt werden. Bitte notiere dir deine Referenz-Nr.',
        fehlerLeer:     'Bitte fülle dieses Feld aus.',
        fehlerEmail:    'Bitte gib eine gültige E-Mail-Adresse ein.',
        fehlerServer:   'Ein Fehler ist aufgetreten. Bitte versuche es erneut.',
      },
      en: {
        btnLabel:       'Withdraw from contract here',
        modalTitel:     'Withdraw from contract',
        modalUntertitel:'Fill in the form below. You will receive an immediate confirmation of receipt by email.',
        pflichthinweis: '* Required fields',
        labelName:      'Full name',
        labelEmail:     'Email address',
        labelArtikel:   'Order number (if known) and/or the relevant items',
        labelArtikelHint: 'e.g. order #12345, item ...',
        labelNachricht: 'Additional information (optional)',
        btnAbschicken:  'Confirm withdrawal',
        btnLaedt:       'Sending…',
        erfolg:         'You will receive a confirmation of receipt by email!',
        erfolgText:     'Please check your inbox: ',
        erfolgId:       'Reference no.',
        erfolgOhneMail: 'Withdrawal submitted',
        erfolgOhneMailText: 'Your withdrawal has been submitted to us. Unfortunately, the confirmation email could not be delivered. Please make a note of your reference number.',
        fehlerLeer:     'Please fill in this field.',
        fehlerEmail:    'Please enter a valid email address.',
        fehlerServer:   'An error occurred. Please try again.',
      },
    },
  };

  /* Aktive Sprache aus <html lang> bestimmen (Fallback: Deutsch).
     Danach zeigt KONFIG.texte auf die Texte der aktuellen Sprache – der
     übrige Code bleibt unverändert. */
  const WB_SPRACHE = (document.documentElement.getAttribute('lang') || 'de').slice(0, 2).toLowerCase();
  KONFIG.texte = KONFIG.texteAlle[WB_SPRACHE] || KONFIG.texteAlle.de;

  /* ============================================================
     HTML-VORLAGE (wird automatisch eingefügt)
     ============================================================ */
  function html_erstellen() {
    return `
<div class="wb-overlay" id="wb-overlay" role="dialog" aria-modal="true"
     aria-labelledby="wb-modal-titel" aria-hidden="true">
  <div class="wb-modal">
    <button class="wb-schliessen" id="wb-schliessen" aria-label="Schließen" type="button">
      &#x2715;
    </button>

    <div class="wb-inhalt">
      <h2 class="wb-titel" id="wb-modal-titel">${KONFIG.texte.modalTitel}</h2>
      <p class="wb-untertitel" id="wb-untertitel">${KONFIG.texte.modalUntertitel}</p>

      <!-- Formular -->
      <form id="wb-formular" novalidate>

        <!-- Honeypot (für Menschen unsichtbar) -->
        <div class="wb-honeypot" aria-hidden="true" style="display:none!important">
          <label for="wb-website">Webseite</label>
          <input type="text" id="wb-website" name="website" tabindex="-1" autocomplete="off">
        </div>

        <p class="wb-pflichthinweis">${KONFIG.texte.pflichthinweis}</p>

        <!-- Name -->
        <div class="wb-feld">
          <label class="wb-label" for="wb-name">
            ${KONFIG.texte.labelName}
            <span class="wb-pflicht" aria-hidden="true">*</span>
          </label>
          <input class="wb-input" type="text" id="wb-name" name="name"
                 autocomplete="name" required maxlength="200">
          <span class="wb-feld-fehler" id="wb-name-fehler" role="alert"></span>
        </div>

        <!-- E-Mail -->
        <div class="wb-feld">
          <label class="wb-label" for="wb-email">
            ${KONFIG.texte.labelEmail}
            <span class="wb-pflicht" aria-hidden="true">*</span>
          </label>
          <input class="wb-input" type="email" id="wb-email" name="email"
                 autocomplete="email" required maxlength="254">
          <span class="wb-feld-fehler" id="wb-email-fehler" role="alert"></span>
        </div>

        <!-- Artikel / Abo -->
        <div class="wb-feld">
          <label class="wb-label" for="wb-artikel">
            ${KONFIG.texte.labelArtikel}
            <span class="wb-pflicht" aria-hidden="true">*</span>
          </label>
          <textarea class="wb-textarea" id="wb-artikel" name="artikel"
                    required rows="3" maxlength="1000"
                    placeholder="${KONFIG.texte.labelArtikelHint}"></textarea>
          <span class="wb-feld-fehler" id="wb-artikel-fehler" role="alert"></span>
        </div>

        <!-- Nachricht (optional) -->
        <div class="wb-feld">
          <label class="wb-label" for="wb-nachricht">
            ${KONFIG.texte.labelNachricht}
          </label>
          <textarea class="wb-textarea" id="wb-nachricht" name="nachricht"
                    rows="2" maxlength="2000"></textarea>
        </div>

        <!-- Cloudflare Turnstile (wird per JS eingefügt wenn aktiv) -->
        <div class="wb-turnstile" id="wb-turnstile"></div>

        <!-- Allgemeine Fehlermeldung (Server) -->
        <div class="wb-allg-fehler" id="wb-allg-fehler" role="alert"></div>

        <!-- Absenden -->
        <button class="wb-abschicken" type="submit" id="wb-abschicken">
          <span class="wb-spinner"></span>
          <span class="wb-btn-text">${KONFIG.texte.btnAbschicken}</span>
        </button>
      </form>

      <!-- Erfolgsmeldung (zunächst versteckt) -->
      <div class="wb-erfolg" id="wb-erfolg" hidden aria-live="polite" tabindex="-1">
        <div class="wb-erfolg-icon">&#x2714;</div>
        <p class="wb-erfolg-titel" id="wb-erfolg-titel"></p>
        <p class="wb-erfolg-text" id="wb-erfolg-text"></p>
        <p class="wb-erfolg-id" id="wb-erfolg-id"></p>
      </div>
    </div>
  </div>
</div>`;
  }

  /* ============================================================
     HILFSFUNKTIONEN
     ============================================================ */

  function el(id) {
    return document.getElementById(id);
  }

  function gueltige_email(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function turnstile_zuruecksetzen() {
    if (KONFIG.turnstileAktiv && typeof turnstile !== 'undefined') {
      turnstile.reset();
    }
  }

  function feld_fehler_setzen(feldId, fehlerId, meldung) {
    const feld   = el(feldId);
    const fehler = el(fehlerId);
    if (!feld || !fehler) return;

    if (meldung) {
      feld.classList.add('wb-fehler-feld');
      fehler.textContent = meldung;
      fehler.classList.add('wb-sichtbar');
    } else {
      feld.classList.remove('wb-fehler-feld');
      fehler.textContent = '';
      fehler.classList.remove('wb-sichtbar');
    }
  }

  function allg_fehler_setzen(meldung) {
    const box = el('wb-allg-fehler');
    if (!box) return;
    if (meldung) {
      box.textContent = meldung;
      box.classList.add('wb-sichtbar');
    } else {
      box.textContent = '';
      box.classList.remove('wb-sichtbar');
    }
  }

  function formular_validieren() {
    let ok = true;

    const name    = el('wb-name').value.trim();
    const email   = el('wb-email').value.trim();
    const artikel = el('wb-artikel').value.trim();

    if (!name) {
      feld_fehler_setzen('wb-name', 'wb-name-fehler', KONFIG.texte.fehlerLeer);
      ok = false;
    } else {
      feld_fehler_setzen('wb-name', 'wb-name-fehler', '');
    }

    if (!email || !gueltige_email(email)) {
      feld_fehler_setzen('wb-email', 'wb-email-fehler', KONFIG.texte.fehlerEmail);
      ok = false;
    } else {
      feld_fehler_setzen('wb-email', 'wb-email-fehler', '');
    }

    if (!artikel) {
      feld_fehler_setzen('wb-artikel', 'wb-artikel-fehler', KONFIG.texte.fehlerLeer);
      ok = false;
    } else {
      feld_fehler_setzen('wb-artikel', 'wb-artikel-fehler', '');
    }

    return ok;
  }

  /* ============================================================
     FORMULAR ZURÜCKSETZEN
     ============================================================ */

  function formular_zuruecksetzen() {
    const form = el('wb-formular');
    if (form) form.reset();

    // Alle Feld-Fehler ausblenden
    document.querySelectorAll('.wb-fehler-feld').forEach(function (f) {
      f.classList.remove('wb-fehler-feld');
    });
    document.querySelectorAll('.wb-feld-fehler, .wb-allg-fehler').forEach(function (f) {
      f.textContent = '';
      f.classList.remove('wb-sichtbar');
    });

    // Button-Zustand zurücksetzen
    const btn = el('wb-abschicken');
    if (btn) {
      btn.disabled = false;
      btn.classList.remove('wb-laedt');
      const btnText = btn.querySelector('.wb-btn-text');
      if (btnText) btnText.textContent = KONFIG.texte.btnAbschicken;
    }

    // UI-Elemente wieder einblenden (falls nach Erfolg ausgeblendet)
    if (form) form.hidden = false;
    const titel = el('wb-modal-titel');
    const untertitel = el('wb-untertitel');
    const erfolg = el('wb-erfolg');
    if (titel) titel.hidden = false;
    if (untertitel) untertitel.hidden = false;
    if (erfolg) {
      erfolg.hidden = true;
      erfolg.classList.remove('wb-sichtbar');
    }

    turnstile_zuruecksetzen();
  }

  /* ============================================================
     MODAL ÖFFNEN / SCHLIEßEN
     ============================================================ */

  let letzterFokus = null; // Fokus nach Schließen wiederherstellen

  function modal_oeffnen(stil) {
    const overlay = el('wb-overlay');
    if (!overlay) return;

    letzterFokus = document.activeElement;

    // Design-Variante auf Overlay setzen
    overlay.removeAttribute('data-wb-stil');
    if (stil) overlay.setAttribute('data-wb-stil', stil);

    overlay.style.display = 'flex';
    // Kleiner Delay damit CSS-Transition greift
    requestAnimationFrame(() => {
      requestAnimationFrame(() => overlay.classList.add('wb-offen'));
    });
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Fokus auf ersten interaktiven Element setzen
    const ersteFeld = overlay.querySelector('input, textarea, button');
    if (ersteFeld) setTimeout(() => ersteFeld.focus(), 250);
  }

  function modal_schliessen() {
    const overlay = el('wb-overlay');
    if (!overlay) return;

    overlay.classList.remove('wb-offen');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    // Transition-Ende abwarten, mit Fallback falls Event nicht feuert
    let transitionErledigt = false;

    overlay.addEventListener('transitionend', function handler() {
      if (transitionErledigt) return;
      transitionErledigt = true;
      overlay.style.display = 'none';
      overlay.removeEventListener('transitionend', handler);
    }, { once: true });

    setTimeout(() => {
      if (!transitionErledigt) {
        transitionErledigt = true;
        overlay.style.display = 'none';
      }
    }, 400);

    // Formular verzögert zurücksetzen (nicht während der Schließ-Animation sichtbar)
    setTimeout(formular_zuruecksetzen, 300);

    if (letzterFokus) letzterFokus.focus();
  }

  /* ============================================================
     FORMULAR ABSENDEN
     ============================================================ */

  let formular_start_zeit = Date.now();

  async function formular_absenden(e) {
    e.preventDefault();
    allg_fehler_setzen('');

    if (!formular_validieren()) {
      // Erstes fehlerhaftes Feld fokussieren
      const erstFehler = document.querySelector('.wb-fehler-feld');
      if (erstFehler) erstFehler.focus();
      return;
    }

    const btn      = el('wb-abschicken');
    const btnText  = btn.querySelector('.wb-btn-text');
    const formular = el('wb-formular');

    // Lade-Zustand aktivieren
    btn.disabled = true;
    btn.classList.add('wb-laedt');
    btnText.textContent = KONFIG.texte.btnLaedt;

    // Turnstile-Token auslesen (falls aktiv)
    let turnstileToken = '';
    if (KONFIG.turnstileAktiv) {
      const turnstileInput = document.querySelector('[name="cf-turnstile-response"]');
      turnstileToken = turnstileInput ? turnstileInput.value : '';
    }

    const nutzlast = {
      name:      el('wb-name').value.trim(),
      email:     el('wb-email').value.trim(),
      artikel:   el('wb-artikel').value.trim(),
      nachricht: el('wb-nachricht').value.trim(),
      website:   el('wb-website').value,          // Honeypot
      _ts:       Math.floor(formular_start_zeit / 1000), // Zeitstempel
      ...(KONFIG.turnstileAktiv && { 'cf-turnstile-response': turnstileToken }),
    };

    try {
      const antwort = await fetch(KONFIG.backendUrl, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(nutzlast),
      });

      const json = await antwort.json();

      if (json.erfolg) {
        // Formular, Titel und Untertitel ausblenden, Erfolgsmeldung zeigen
        formular.hidden = true;
        el('wb-modal-titel').hidden = true;
        el('wb-untertitel').hidden  = true;
        const erfolg = el('wb-erfolg');

        // Warnung vom Backend auswerten (Kunden-Mail fehlgeschlagen?)
        if (json.warnung === 'kunden_mail_fehler') {
          el('wb-erfolg-titel').textContent = KONFIG.texte.erfolgOhneMail;
          el('wb-erfolg-text').textContent  = json.nachricht || KONFIG.texte.erfolgOhneMailText;
        } else {
          el('wb-erfolg-titel').textContent = KONFIG.texte.erfolg;
          el('wb-erfolg-text').textContent  =
            KONFIG.texte.erfolgText + ' ' + nutzlast.email + '.';
        }

        el('wb-erfolg-id').textContent    =
          json.widerrufs_id
            ? KONFIG.texte.erfolgId + ' ' + json.widerrufs_id
            : '';
        erfolg.hidden = false;
        erfolg.classList.add('wb-sichtbar');
        erfolg.focus();
      } else {
        allg_fehler_setzen(json.fehler || KONFIG.texte.fehlerServer);
        btn.disabled = false;
        btn.classList.remove('wb-laedt');
        btnText.textContent = KONFIG.texte.btnAbschicken;
        turnstile_zuruecksetzen();
      }
    } catch {
      allg_fehler_setzen(KONFIG.texte.fehlerServer);
      btn.disabled = false;
      btn.classList.remove('wb-laedt');
      btnText.textContent = KONFIG.texte.btnAbschicken;
      turnstile_zuruecksetzen();
    }
  }

  /* ============================================================
     TASTATUR-ZUGÄNGLICHKEIT (Fokus-Falle im Modal)
     ============================================================ */

  function fokus_falle(e) {
    const overlay = el('wb-overlay');
    if (!overlay || !overlay.classList.contains('wb-offen')) return;

    const fokussierbar = Array.from(
      overlay.querySelectorAll(
        'button:not(:disabled), input:not(:disabled):not(.wb-honeypot input), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(el => !el.closest('.wb-honeypot'));

    if (fokussierbar.length === 0) return;

    const erster = fokussierbar[0];
    const letzter = fokussierbar[fokussierbar.length - 1];

    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === erster) {
          e.preventDefault();
          letzter.focus();
        }
      } else {
        if (document.activeElement === letzter) {
          e.preventDefault();
          erster.focus();
        }
      }
    }

    if (e.key === 'Escape') {
      modal_schliessen();
    }
  }

  /* ============================================================
     CLOUDFLARE TURNSTILE LADEN
     ============================================================ */

  function turnstile_laden() {
    if (!KONFIG.turnstileAktiv) return;

    const container = el('wb-turnstile');
    if (!container) return;

    // Turnstile-Script nur einmal laden
    if (!document.querySelector('script[src*="turnstile"]')) {
      const script  = document.createElement('script');
      script.src    = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async  = true;
      script.defer  = true;
      document.head.appendChild(script);
    }

    // Widget einfügen
    container.innerHTML =
      `<div class="cf-turnstile" data-sitekey="${KONFIG.turnstileSitekey}" data-theme="light"></div>`;
  }

  /* ============================================================
     INITIALISIERUNG
     ============================================================ */

  function init() {
    // Modal-HTML in den Body einfügen
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html_erstellen();
    document.body.appendChild(wrapper.firstElementChild);

    // Turnstile laden (falls aktiv)
    turnstile_laden();

    // Zeitstempel setzen (für Bot-Erkennung)
    formular_start_zeit = Date.now();

    // Schließen-Button
    el('wb-schliessen').addEventListener('click', modal_schliessen);

    // Klick auf Overlay (außerhalb Modal) schließt es
    el('wb-overlay').addEventListener('click', function (e) {
      if (e.target === this) modal_schliessen();
    });

    // Tastatur-Ereignisse
    document.addEventListener('keydown', fokus_falle);

    // Formular abschicken
    el('wb-formular').addEventListener('submit', formular_absenden);

    // Live-Validierung: Fehler beim Verlassen des Feldes entfernen
    ['wb-name', 'wb-email', 'wb-artikel'].forEach(function (id) {
      el(id).addEventListener('blur', function () {
        if (this.value.trim()) {
          if (id === 'wb-email' && !gueltige_email(this.value.trim())) return;
          feld_fehler_setzen(id, id + '-fehler', '');
        }
      });
    });

    // Widerrufs-Buttons auf der Seite aktivieren (Beschriftung je Sprache setzen)
    document.querySelectorAll('[data-wb-oeffnen]').forEach(function (btn) {
      if (KONFIG.texte.btnLabel) btn.textContent = KONFIG.texte.btnLabel;
      btn.addEventListener('click', function () {
        const stil = this.dataset.wbOeffnen || null;
        // Zeitstempel zurücksetzen (Nutzer beginnt Formular jetzt)
        formular_start_zeit = Date.now();
        modal_oeffnen(stil);
      });
    });
  }

  // DOM bereit?
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
